import { useTranslation } from 'react-i18next';
import { pickLocalized, type LocalePartialText } from './i18n-text';

/**
 * Returns a function that picks the string for the active i18next locale
 * from a backend localized payload ({ru,en,uz}). Falls back to en → first
 * available → "".
 */
export function useLocalizedText() {
  const { i18n } = useTranslation();
  return (value: LocalePartialText | null | undefined): string =>
    pickLocalized(value, i18n.language || 'en');
}
